var styles = {"progressIndicator":"VBG__DS__compact-progress-indicator-module__E6sB_","vertical":"VBG__DS__compact-progress-indicator-module__uuu2P"};

export { styles as default };
